// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1198":"b05cbb47","2220":"9e00702f","2940":"8ea63003","7886":"7ad3a4a3"}[chunkId] + ".chunk.css";
};